import {ConfigObjectType, useApiQuery} from '@wallaby-ui/core';

import {AlertBoardChartDto} from './alert_board_chart_types';

type UseAlertBoardChartReturn = {
  chart: AlertBoardChartDto | undefined;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
};

/**
 * The board's dynamics chart read (PDW-248): `GET {alertBoardChart}` with the board's filter and the breakdown and the
 * values, but no page and no sort, so paging or sorting the table never recounts the months. A separate read from the
 * table's, so switching the breakdown never rereads the table. Fetched again on every mount, as the board.
 */
export function useAlertBoardChart(config: ConfigObjectType, params: URLSearchParams, enabled: boolean): UseAlertBoardChartReturn {
  const url: string = config.service.url.alertBoardChart ?? '';
  const {data, isLoading, isFetching, isError} = useApiQuery<AlertBoardChartDto>([url, String(params)], null, {
    axiosConfig: {url, params},
    reactQueryOptions: {
      enabled: enabled && Boolean(url),
      staleTime: 0,
      refetchOnMount: 'always',
      keepPreviousData: true,
    },
  });
  return {chart: data, isLoading, isFetching, isError};
}
